import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import HeroSlider from './components/HeroSlider';
import ServicesSection from './components/ServicesSection';
import CompanyPresentationSection from './components/CompanyPresentationSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import ProjectCTASection from './components/ProjectCTASection';
import CommitmentsSection from './components/CommitmentsSection';
import HomeNewsSection from './components/HomeNewsSection';
import KinshasaMapSection from './components/KinshasaMapSection';
import QuestionsCTASection from './components/QuestionsCTASection';
import Footer from './components/Footer';
import ProjectFormPage from './pages/ProjectFormPage';
import AboutUsPage from './pages/AboutUsPage';
import ActualitesPage from './pages/ActualitesPage';
import ConstructionMaisonPage from './pages/ConstructionMaisonPage';
import ConstructionImmeublePage from './pages/ConstructionImmeublePage';
import InfrastructuresEnergetiquesPage from './pages/InfrastructuresEnergetiquesPage';
import RenovationPage from './pages/RenovationPage';
import PublicationsPage from './pages/PublicationsPage';
import PublicationArticlePage from './pages/PublicationArticlePage';
import GciEntrepriseEngageePage from './pages/GciEntrepriseEngageePage';
import NosPartenairesPage from './pages/NosPartenairesPage';
import LiorTechnologiePage from './pages/LiorTechnologiePage';
import EspaceDocumentsPage from './pages/EspaceDocumentsPage';
import { Toaster } from './components/ui/sonner';
import ChatWidget from './components/ChatWidget';
import './App.css';

const HomePage = () => {
  return (
    <>
      <Header />
      <main className="pt-[240px]">
        <HeroSlider />
        <ServicesSection />
        <CompanyPresentationSection />
        <AboutSection />
        <FeaturesSection />
        <ProjectCTASection />
        <CommitmentsSection />
        <KinshasaMapSection />
        <QuestionsCTASection />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/qui-sommes-nous" element={<Navigate to="/qui-sommes-nous/gci-entreprise-engagee" replace />} />
          <Route path="/qui-sommes-nous/gci-entreprise-engagee" element={<GciEntrepriseEngageePage />} />
          <Route path="/qui-sommes-nous/notre-equipe" element={<AboutUsPage />} />
          <Route path="/qui-sommes-nous/nos-partenaires" element={<NosPartenairesPage />} />
          <Route path="/qui-sommes-nous/nos-partenaires/lior-technologie-ingenierie" element={<LiorTechnologiePage />} />
          <Route path="/qui-sommes-nous/espace-documents" element={<EspaceDocumentsPage />} />
          <Route path="/actualites" element={<PublicationsPage />} />
          <Route path="/actualites/:slug" element={<PublicationArticlePage />} />
          <Route path="/votre-projet" element={<ProjectFormPage />} />
          <Route path="/services/construction-maison" element={<ConstructionMaisonPage />} />
          <Route path="/services/construction-immeuble" element={<ConstructionImmeublePage />} />
          <Route path="/services/infrastructures-energetiques" element={<InfrastructuresEnergetiquesPage />} />
          <Route path="/services/renovation" element={<RenovationPage />} />
          <Route path="/publications" element={<ActualitesPage />} />
        </Routes>
        <ChatWidget />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
